// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Oe","itemsContainer":"Pe"};